import React from 'react';
import {connect} from 'react-redux';
import {sendLocaleStorage} from '../../../common/device/actions';

class SendLocalestorage extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        sendLocaleStorage: React.PropTypes.func,
        deviceId: React.PropTypes.number,
        onlineState: React.PropTypes.bool
    };

    constructor(props) {
        super(props);

        this.sendLocalstorageToServer = this.sendLocalstorageToServer.bind(this);
    }

    sendLocalstorageToServer() {
        const {sendLocaleStorage, deviceId} = this.props;
        if (typeof localStorage !== 'undefined' && localStorage.getItem('redux-storage:ocellot-pos')) {
            const note = prompt('Poznámka');
            sendLocaleStorage(localStorage.getItem('redux-storage:ocellot-pos'), deviceId, note);
        }
    }

    render() {
        const {msg, onlineState} = this.props;

        return (
            <div className="table-row">
                <div className="table-cell" style={{width: '55.55%'}}>
                    <div className="boxBtn text-black text-left">
                        <div className="boxBtn-inner">
                            <div className="settings-name">
                                <span className="settings-name-name">{msg.settings.localstorage.title}</span>
                                <span className="settings-name-info">{msg.settings.localstorage.subtitle}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="table-cell" style={{width: '44.44%'}}>
                    <div className={`boxBtn color-green text-l ${onlineState ? '' : 'disabled'}`}>
                        <div className="boxBtn-inner" onClick={this.sendLocalstorageToServer}>
                            <span>{msg.settings.localstorage.send}</span>
                            {!onlineState &&
                            <span>{msg.menu.offlineMode}</span>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );

    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    deviceId: state.device.get('id'),
    onlineState: state.categories.get('onlineState')
}), {sendLocaleStorage})(SendLocalestorage);



// WEBPACK FOOTER //
// ./src/browser/menu/settings/SendLocalestorage.js